import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';

export const saQuestionElement = css`
	.CodeMirror {
		height: auto;
		border: 1px solid ${colors.border};
		border-radius: 4px;
		padding: 6px 12px;
		font-size: 16px;
		font-family: inherit;
		color: ${colors.mainText};
	}

	.answer {
		display: flex;
		background-color: ${colors.background};
		border: 1px solid ${colors.border};
		border-radius: 4px;

		.block {
			min-width: 39px;
		}

		.react-codemirror2 {
			width: 100%;
		}

		.CodeMirror {
			font-size: 14px;
			border: none;
			border-left: 1px solid #ced4da;
			border-top-left-radius: unset;
			border-bottom-left-radius: unset;
		}
	}
`;
